import { ApexOptions } from "apexcharts";
import { ExamPeriodMonitor, ExamPeriodMonitorState } from "@types";
import { TFunction } from "i18next";

export const periodAcitivityChartOptions = (t: TFunction<"translation", undefined>, monitorData?: ExamPeriodMonitor[], ): ApexOptions => {

    let showParticipants =
      monitorData?.filter(
        (item) =>
          item.state === ExamPeriodMonitorState.ParticipantConfirmed ||
          item.state === ExamPeriodMonitorState.InProgress ||
          item.state === ExamPeriodMonitorState.Completed ||
          item.state === ExamPeriodMonitorState.Paused ||
          item.state === ExamPeriodMonitorState.Excluded
      ).length || 0;
    let notShowParticipants = monitorData?.filter((item) => item.state === ExamPeriodMonitorState.NoShow).length || 0;
          
    return {
      series: [showParticipants, notShowParticipants],
    chart: {
        width: 380,
        type: 'donut',
        background: 'transparent'
      },
    labels: [t("pages.examPeriods.showed"), t("pages.examPeriods.notShowed")],
    tooltip: {
    enabled: true
    },
    legend: {
        position: 'bottom'
    },   
  }
}

export const periodActivityPassageChartOptions = (t: TFunction<"translation", undefined>, monitorData?: ExamPeriodMonitor[], ): ApexOptions => {

    let passedParticipants = monitorData?.filter((item) => {
      if (item.state === ExamPeriodMonitorState.Completed && item.hasPassed) {
        return true;
      }
      return false
    }).length || 0;
    let notPassedParticipants = monitorData?.filter((item) => {
      if (item.state === ExamPeriodMonitorState.Completed && !item.hasPassed) {
        return true;
      }
      return false
    }).length || 0;
    let excludedParticipants = monitorData?.filter((item) => item.state === ExamPeriodMonitorState.Excluded).length || 0;
          
    return {
      series: [passedParticipants, notPassedParticipants, excludedParticipants],
    chart: {
        width: 380,
        type: 'donut',
        background: 'transparent'
      },

      colors: ['#00E396', '#FF4560', '#775DD0'],
    labels: [t("table.passed"), t("table.failed"), t("table.disqulified")],
    tooltip: {
    enabled: true
    },
    legend: {
        position: 'bottom'
    },   
  }
}

